import styled from 'styled-components';
import {GreenPlusIcon} from "../../assets/images";
import {TabView} from "../../components/LayoutOptions/layoutOptionsStyles";
import {OutlinedInput} from "../../components/Inputs/inputsStyles";

export const Wrapper = styled.div`
    width: 100vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 22px 65px 22px;
    background-color: ${(props) => props.theme.bg.workspace};

    textarea:focus, input:focus {
        outline: none;
    }

`;

export const TabName = styled.h2`
    font-weight: normal;
`;

export const AddTickersFieldDiv = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${(props) => props.theme.color.addingGreen};
    box-shadow: 0 0 5px rgba(49, 69, 49, 0.14);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    :hover {
        //filter: brightness(98%);
        //z-index: 0;
    }


`;

export const TextDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CustomGreenPlusIcon = styled(GreenPlusIcon)`
    margin-right: 16px;
`;

export const AddText = styled.h4`
    font-weight: normal;
    font-size: 16px;
    color: ${(props) => props.theme.text.mainGreen};
    margin: 0;

`;

interface ITableWrap {
    resize?: string
    tabWidth?: string
    tabHeight?: string
    maxHeight?: string
    maxWidth?: string
    stick?: string
}

export const TableWrap = styled(TabView)<ITableWrap>`
    position: relative;
    background: inherit;
    border: none;
    box-sizing: border-box;
    border-radius: unset;
    font-size: 48px;
    line-height: initial;
    width: ${props => props.tabWidth || "100%"};
    height: ${props => props.tabHeight || "100%"};
    max-height: ${props => props.maxHeight || "auto"};
    max-width: ${props => props.maxWidth || "auto"};
    min-height: 40%;
    flex-wrap: nowrap;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    resize: ${props => props.resize || "none"};
`;

export const TitleInput = styled(OutlinedInput)`
    width: 300px;
    height: auto;
    border: none;
    font-size: 24px;
    border-radius: 0;

    :focus {
        border-bottom: 2px solid #7CBE7B;
        padding-left: 12px;
    }

`;
export const MockTitle = styled.h4`
    width: 300px;
    height: auto;
    border: none;
    font-size: 24px;
    border-radius: 0;

    :focus {
        border-bottom: 2px solid #7CBE7B;
        padding-left: 12px;
    }

`;



